import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card'; // Assuming shadcn UI Card is used
import { CheckCircle } from 'lucide-react'; // Example icon

interface NotificationDemoWidgetProps {
    // Props can be added later if needed, for now, it's static content
    id: string;
    title?: string; // Allow overriding title
    text?: string; // Allow overriding text
    imageUrl?: string; // Allow overriding image
}

export const NotificationDemoWidget: React.FC<NotificationDemoWidgetProps> = ({
    id,
    title = "Kwartaal Doel Bereikt!",
    text = "Gefeliciteerd! We hebben ons gezamenlijke kwartaaldoel voor dit kwartaal succesvol behaald. Goed werk team!",
    // Placeholder image URL - replace with a relevant one if available
    imageUrl = "https://via.placeholder.com/400x200.png?text=Doel+Behaald!" 
}) => {
    return (
        <Card className="h-full flex flex-col overflow-hidden">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 bg-green-100 dark:bg-green-900/30">
                <CardTitle className="text-sm font-medium text-green-800 dark:text-green-300">{title}</CardTitle>
                <CheckCircle className="h-4 w-4 text-green-600 dark:text-green-400" />
            </CardHeader>
            <CardContent className="p-0 flex-1 flex flex-col">
                {imageUrl && (
                    <img 
                        src={imageUrl} 
                        alt={title} 
                        className="w-full h-32 object-cover" // Adjust height as needed
                    />
                )}
                <div className="p-4 flex-1">
                    <p className="text-sm text-muted-foreground">{text}</p>
                </div>
            </CardContent>
        </Card>
    );
};

// Optional: Add default export if preferred elsewhere
// export default NotificationDemoWidget; 